import WorkspaceRole from "./workspace-role";
import {useState} from "react";
import {useTranslate} from "../../system/useTranslate";

export function useWorkspaceRole() {
    const [loading, setLoading] = useState(false);
    const translate = useTranslate();
    const getWorkspaceRoles = async (workspaceId)=>{
        setLoading(true);
        try {
            const workspaceRole = new WorkspaceRole();
            const query = {
                filters: {
                    $and:[
                        {workspace:{$eq: workspaceId}},
                        // {members: {id:{$eq: user.id}}}
                    ],
                },
                populate:"*"
            }
            const _data = await workspaceRole.getAll(query);
            setLoading(false);
            return _data.data.map(d=>({label:translate(d.name), value:d.id, disabled:d.name==="Owner", permissions:d.permissions}))
        }catch (e) {
            setLoading(false);
        }

    }

    return {getWorkspaceRoles};
}
